import { all } from "redux-saga/effects";

import notificaciones from "./notificaciones";
import usuario from "./usuario";
import lista from "./lista";
import diasjefe from "./diasjefe";
import dias from "./dias";
import anticipos from "./anticipos";
import elementos from "./elementos";
import equipos from "./equipos";
import vehiculo from "./vehiculo";

export default function* rootSaga() {
  yield all([
    notificaciones(),
    usuario(),
    lista(),
    diasjefe(),
    dias(),
    anticipos(),
    elementos(),
    equipos(),
    vehiculo(),
  ]);
}
